import type { FilterGroup } from '../types/filters';

export function getCategoryFromType(filterGroups: FilterGroup[], type: string) {
  return filterGroups.find(filterGroup => filterGroup.slug === type);
}

export function getFilterFromValue(filterGroup: FilterGroup, value: string) {
  return filterGroup.values.find(filter => filter.value === value);
}

export function getFilterFromName(filterGroup: FilterGroup, name: string) {
  return filterGroup.values.find(filter => filter.name === name);
}

export function getFilterFromFilterGroups(
  filterGroups: FilterGroup[],
  identifier: string,
  value: string,
) {
  let foundFilter;
  let filterGroup = getCategoryFromType(filterGroups, identifier);

  if (filterGroup) {
    foundFilter = getFilterFromValue(filterGroup, value);
  }

  return foundFilter;
}

export function getActiveFilters(filterGroups: FilterGroup[]): Object {
  return filterGroups.reduce((mem, filterGroup) => {
    if (filterGroup.slug === 'features') return mem;
    let result = filterGroup.values.reduce((mem, filter) => {
      if (filter.on) mem.push(filter.value);
      return mem;
    }, []);
    if (result.length) {
      let resultType = filterGroup.values[0].type;
      if (resultType) {
        let currentValues = mem[resultType] || [];
        mem[resultType] = [...currentValues, ...result];
      }
    }
    return mem;
  }, {});
}

const FilterSelector = {
  getCategoryFromType,
  getFilterFromValue,
  getFilterFromName,
  getFilterFromFilterGroups,
  getActiveFilters,
};

export default FilterSelector;
